module.exports = __webpack_public_path__ + "static/media/portfolio.0486541e.jpg";